import React from "react";
import { ControlLabel, Button, Alert, FormControl } from "react-bootstrap";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import util from "../lib/util.js";
import { browserHistory } from "react-router";

export default class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            errors: [],
            successMessage: ''
        };

        this.loadViewModel = this.loadViewModel.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
    }

    loadViewModel() {
        let self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        ajax.vm().get(`forgot-password`)
            .then(function (res) {
                self.setState({
                    forgotPasswordTitle: res.data.forgotPasswordTitle,
                    forActiveEmployeeHeader: res.data.forActiveEmployeeHeader,
                    forActiveEmployeeMessage: res.data.forActiveEmployeeMessage,
                    forLOAAndFormerEmployeeHeader: res.data.forLOAAndFormerEmployeeHeader,
                    forLOAAndFormerEmployeeMessage: res.data.forLOAAndFormerEmployeeMessage,
                    continueLabel: res.data.continueLabel,
                    cancelLabel: res.data.cancelLabel,
                    sampleEmailLabel: res.data.sampleEmailLabel,
                    forgotPasswordSubmittedMessage: res.data.forgotPasswordSubmittedMessage,
                    loginLabel: res.data.loginLabel
                });

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                },
                function() { 
                    browserHistory.push(context.routeUrl('login')); 
                });
            });
    }

    onEmailChange(event) {
        this.setState({
            email: event.target.value
        });
    }

    onSubmitClick() {
        var messages = this.validate();
        this.setState({
            errors: messages,
            reportData: null
        });

        if (messages.length == 0) {
            this.submit();
        }
    }

    onCancelClick() {
        browserHistory.push(context.routeUrl('login'));
    }

    submit() {
        let self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Submitting. Please wait..."
        });

        ajax.api().get(`forgot-password-submit`, {
            params: {
                email: self.state.email
            }
        })
            .then(function (res) {
                self.setState({
                    successMessage: self.state.forgotPasswordSubmittedMessage
                });

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    validate() {
        let msg = [];

        if (this.state.email.trim() == '') {
            msg.push('Email is required');
        }
        else if (util.isEmail(this.state.email.trim()) == false) {
            msg.push('Please enter valid email.');
        }

        return msg;
    }

    render() {
        return (
            <div>
                <section className="ap-l-section ap-section-hero login">
                    <div className="container">
                        <div className="row">
                            <h2 className="text-center">{this.state.forgotPasswordTitle}</h2>
                        </div>
                        <div className={"row" + (this.state.successMessage.length > 0 ? ' ap-hidden' : '') }>
                            <div className="col-md-offset-2 col-lg-offset-2  col-md-8 col-lg-8">
                                <div className="ap-forgot-password-section-container">
                                    <div className="row">
                                        <div className="col-md-12 col-lg-12 text-center ap-black-color"><ControlLabel>{this.state.forActiveEmployeeHeader}</ControlLabel></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 col-lg-12 text-center"><ControlLabel>{this.state.forActiveEmployeeMessage}</ControlLabel></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"row" + (this.state.successMessage.length > 0 ? ' ap-hidden' : '') }>
                            <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                <div className="ap-forgot-password-section-container">
                                    <div className="row">
                                        <div className="col-md-12 col-lg-12 text-center ap-black-color"><ControlLabel>{this.state.forLOAAndFormerEmployeeHeader}</ControlLabel></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 col-lg-12 text-center"><ControlLabel>{this.state.forLOAAndFormerEmployeeMessage}</ControlLabel></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                            <FormControl type="email" 
                                                value={this.state.email}
                                                onChange={this.onEmailChange}
                                                maxLength="50"
                                                placeholder={this.state.sampleEmailLabel}></FormControl>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2 col-lg-2"></div>
                                        <div className="col-md-4 col-lg-4">
                                            <Button onClick={this.onSubmitClick} className="btn-info ap-fullsize">{this.state.continueLabel}</Button>
                                        </div>
                                        <div className="col-md-4 col-lg-4">
                                            <Button onClick={this.onCancelClick} className="btn-info ap-fullsize">{this.state.cancelLabel}</Button>
                                        </div>
                                        <div className="col-md-2 col-lg-2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"row" + (this.state.successMessage.length > 0 ? ' ap-hidden' : '') }>
                            <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                <Alert bsStyle="danger" className={this.state.errors.length > 0 ? "" : "ap-hidden"}>
                                    <ul className="text-left">
                                        {this.state.errors.map(m =>
                                            <li key={m}>{m}</li>)}
                                    </ul>
                                </Alert>
                            </div>
                        </div>
                        <div className={"row " + (this.state.successMessage == '' ? 'ap-hidden' : '')}>
                            <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                <Alert bsStyle="success">
                                    <ControlLabel>{this.state.successMessage}</ControlLabel>
                                </Alert>
                            </div>
                        </div>
                        <div className={"row " + (this.state.successMessage == '' ? 'ap-hidden' : '')}>
                            <div className="col-md-5 col-lg-5"></div>
                            <div className="col-md-2 col-lg-2">
                                <Button onClick={this.onCancelClick} className="btn-info ap-fullsize">{this.state.loginLabel}</Button>
                            </div>
                            <div className="col-md-5 col-lg-5"></div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}